/**
 * ComplianceField — Wraps a form field or display value with a light-blue left border
 * to indicate it is compliance-certified data.
 */

interface ComplianceFieldProps {
  children: React.ReactNode;
  className?: string;
}

export function ComplianceField({ children, className = '' }: ComplianceFieldProps) {
  return (
    <div
      className={`border border-blue-300 rounded-md p-2 ${className}`}
      title="TR128 Compliance-certified data (SS 626:2024)"
    >
      {children}
    </div>
  );
}
